import React from "react";
import styled from "styled-components";

import Button from "partials/Button";
import Image from "partials/Image";
import FavoriteButton from "partials/FavoriteButton";
import SmartLink from "partials/SmartLink";

import { capitalize } from "helpers";
import WP from "WP";

import { getDate } from "./HandleDate";

import Clock from "icons/ClockIcon";
import Calendar from "icons/CalenderIcon";

import Media from "css/Media";

export const ActivityCard = (props) => {
  const { item } = props;

  return (
    <Card key={item.id} className={props.className}>
      <StyledFavoriteButton sort={item.type} item={item} hasBackground />
      <SmartLink to={item.link}>
        <StyledImage image={item.acf.featured_image} ratio='5:4.4' background>
          <h3>{item.acf.item_name}</h3>
        </StyledImage>
      </SmartLink>
      <InfoBox>
        <ActivityInfo>
          <div>
            <Calendar />
            {getDate(item.acf.from_date)} - {getDate(item.acf.to_date)}
          </div>
          <div>
            <Clock />
            <p>
              {item.acf.duration} {WP.trans.hours}
            </p>
          </div>
        </ActivityInfo>
        <PriceInfo>
          <span>
            {capitalize(WP.trans.perPerson)} NOK {item.acf.price}
          </span>
          <SmartLink to={item.link}>
            <Button>{WP.trans.readMoreAndOrder}</Button>
          </SmartLink>
        </PriceInfo>
      </InfoBox>
    </Card>
  );
};

export default ActivityCard;

const Card = styled.div`
  width: 100%;

  h3 {
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: ${(props) => props.theme.colors.negative};
    color: ${(props) => props.theme.colors.text};
    padding: ${(props) => props.theme.spacing.contentL}
      ${(props) => props.theme.spacing.elementXS};
    width: 78.719723183391%;
    height: 27.6%;
    z-index: 1;
  }
`;

const StyledImage = styled(Image)`
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    content: "";
    background-color: transparent;
    transition: all 0.2s ease-in;
  }

  &:hover {
    &::after {
      background-color: rgba(0, 0, 0, 0.2);
    }
    svg {
      opacity: 1;
    }
  }
`;

const StyledFavoriteButton = styled(FavoriteButton)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 63.97px;
  height: 61.597px;
  position: absolute;
  z-index: 10;
  top: 0;
  right: calc((100vw - 80px) / 100 * 8.8);

  ${Media.greaterThan("s")`
        width: 103.97px;
        height: 101.597px;
        right: calc((100vw - 80px) / 100 * 3.65);
    `}

  ${Media.greaterThan("m")`
        right: calc((100vw - 80px) / 100 * 2.59);
    `}
`;

const PriceInfo = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  span {
    ${(props) => props.theme.fonts.p}
    text-align: center;
    line-height: 25px;
    padding-bottom: 14px;
  }

  > div {
    padding-bottom: ${(props) => props.theme.spacing.contentM};
  }
`;

const InfoBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: ${(props) => props.theme.spacing.contentXL}
    ${(props) => props.theme.spacing.elementXS};
  background-color: ${(props) => props.theme.colors.bg};
  color: ${(props) => props.theme.colors.text};
`;

const ActivityInfo = styled.div`
  margin: auto 0;

  > div {
    display: flex;
    align-items: center;
    margin-bottom: ${(props) => props.theme.spacing.contentL};

    &:last-of-type {
      margin-bottom: 0;
    }

    svg {
      fill: ${(props) => props.theme.colors.text};
      margin-right: ${(props) => props.theme.spacing.contentM};
    }
  }
`;
